import Vue from "vue";
import VueRouter from "vue-router";

import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
  getHomeRouteForLoggedInRider,
} from "@/auth/utils";

import pages from "../router/page/page";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    ...pages,
    {
      path: "/",
      name: "profile",
      component: () => import("@/views/users-view/UsersView.vue"),
      meta: {
        pageTitle: "menu.profile",
        breadcrumb: [
          {
            text: "menu.profile",
            active: true,
          },
        ],
      },
    },
    {
      path: "/second-page",
      name: "second-page",
      component: () => import("@/views/SecondPage.vue"),
      meta: {
        pageTitle: "Second Page",
        breadcrumb: [
          {
            text: "Second Page",
            active: true,
          },
        ],
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach((to, _, next) => {
  const { authorize } = to.meta;
  if (localStorage.getItem("username")) {
    if (authorize) {
      next({ name: "auth-login" });
    }
  }
  //  const isLoggedIn = isUserLoggedIn()

  // // Redirect to login if not logged in
  // if (!isLoggedIn) return next({ name: 'auth-login' })

  // // Redirect if logged in
  // if (to.meta.redirectIfLoggedIn && isLoggedIn) {
  //     const userData = getUserData()
  //     next(getHomeRouteForLoggedInUser("admin"))
  // }

  next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
